import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ProgressModalProps } from 'components/shared/dialogs/ProgressModal/ProgressModal.types';
import { ProgressBar } from 'components/shared/loaders/ProgressBar/ProgressBar';
import React, { FC } from 'react';
import classNames from 'classnames';
import { useModalClosedContext } from 'context/ModalClosedContext';

export const ProgressModal: FC<ProgressModalProps> = (props) => {
  const { notifyModalClosed } = useModalClosedContext();
  const handleButtonClick = () => {
    props.button.action();
    notifyModalClosed();
  };
  return (
    <Dialog fullWidth maxWidth={'md'} disableEscapeKeyDown aria-labelledby="import-status-title" open={props.open}>
      <DialogTitle id="confirm-title">{props.title}</DialogTitle>
      <DialogContent>
        <ProgressBar value={props.progress} error={props.error} />
        <div className="mt-3">
          <DialogContentText className={classNames({ 'text-danger': props.error })}>
            {props.description}
          </DialogContentText>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleButtonClick}
          color="primary"
          variant="outlined"
          data-testid="confirm-yes"
          disabled={props.button.disabled}
        >
          {props.button.label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
